import { MAIL_VIEWS } from "../constants.js";
import { create } from "zustand";
//#region src/modules/Mail/stores/MailStore.ts
var useMailStore = create()((set, get) => ({
	activeTab: MAIL_VIEWS.INBOX,
	addSelectedMessage: (messageId) => {
		const messagesIds = {
			...get().selectedMessagesIds,
			[messageId]: messageId
		};
		set({
			amountOfSelectedMessages: Object.keys(messagesIds).length,
			selectedMessagesIds: messagesIds
		});
	},
	amountOfSelectedMessages: 0,
	folder: MAIL_VIEWS.INBOX,
	isSelectingMessages: false,
	messageSearchValue: "",
	removeSelectedMessage: (messageId) => {
		const messagesIds = get().selectedMessagesIds;
		delete messagesIds[messageId];
		set({
			amountOfSelectedMessages: Object.keys(messagesIds).length,
			selectedMessagesIds: messagesIds
		});
	},
	resetSelectedMessages: () => set({
		amountOfSelectedMessages: 0,
		selectedMessagesIds: {}
	}),
	selectedMessagesIds: {},
	setActiveTab: (activeTab) => set({ activeTab }),
	setFolder: (folder) => set({ folder }),
	setIsSelectingMessages: (isSelectingMessages) => set({ isSelectingMessages }),
	setMessageSearchValue: (newSearch) => set({ messageSearchValue: newSearch }),
	setView: (view) => set({ view }),
	view: MAIL_VIEWS.INBOX
}));
//#endregion
export { useMailStore };

//# sourceMappingURL=MailStore.js.map